export const noDdiPhone = /(\(?[0-9]{2}\)?\s?[0-9]?\s?[0-9]{4}-?[0-9]{4})|([0-9]{4}\s?[0-9]{3}\s?[0-9]{4})/;